import { ClipboardList } from "lucide-react";
import { DailyLogPanel } from "@/components/daycare/DailyLogPanel";

export default function DailyLogPage() {
  return (
    <div className="p-6 lg:p-8" data-testid="daily-log-page">
      <header className="mb-6">
        <div className="text-[11px] font-semibold uppercase tracking-widest text-slate-500 inline-flex items-center gap-1.5"><ClipboardList className="h-3.5 w-3.5" /> Daycare</div>
        <h1 className="font-display text-2xl font-bold tracking-tight text-slate-900">Daily Log</h1>
        <p className="text-sm text-slate-500">Meals, naps, diapers, activities, moods and photos for every room — parents see it live in the parent app and get an end-of-day email.</p>
      </header>
      <DailyLogPanel />
    </div>
  );
}
